import React, { FC } from 'react';
import { useOrders } from './orders-hooks';

import { CircularProgress, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import VoidOrders from 'components/order-void-screen/orders-void-screen';
import { useUserInformationContext } from 'contexts/userContext';

import Header from './components/header';
import ModalCreateOrders from './components/modal-create-orders/modal-create-orders';
import OrdersTabs from './components/order-tabs';
import OrdersTable from './components/orders-table';
import { MapTab } from './components/MapTab';
import { OrdersContext } from './ordersContext';

const useStyles = makeStyles((theme: any) => ({
  container: { padding: theme.spacing(3) },
  mainContainer: { marginTop: theme.spacing(5) },
  loadingContainer: { height: '60vh' },
  loading: { color: theme.accent.main },
  voidContainer: { height: '70vh' },
}));

type OrdersProps = {
  agencySelected?: string;
};

export const Orders: FC<OrdersProps> = (props) => {
  const { agencySelected } = props;
  const ordersState = useOrders(agencySelected);
  const {
    t,
    filter,
    currentData,
    orders,
    loading,
    agencyName,
    state,
    viewTabValue,
    handleViewTabValueChange,
    handleModalOpen,
    handleChangeFilter,
    handleSelectRow,
    handleTablePageChange,
  } = ordersState;

  const classes = useStyles();
  const { userIsTitleAdmin } = useUserInformationContext();

  return (
    <OrdersContext.Provider value={ordersState}>
      <Grid container className={classes.container}>
        <Grid item xs={12}>
          <Header
            t={t}
            userIsTitleEmployee={userIsTitleAdmin}
            handleModalOpen={handleModalOpen}
            agencyName={agencyName}
          />
        </Grid>

        <Grid item xs={12} className={classes.mainContainer}>
          <Grid container>
            <Grid item xs={12}>
              <OrdersTabs
                t={t}
                filter={filter}
                handleChangeFilter={handleChangeFilter}
                viewTabValue={viewTabValue}
                onViewTabValueChange={handleViewTabValueChange}
              />
            </Grid>

            {!loading && !orders.length && viewTabValue === "table" && (
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                className={classes.voidContainer}
              >
                <Grid item>
                  <VoidOrders />
                </Grid>
              </Grid>
            )}

            {loading && viewTabValue === "table" && (
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                className={classes.loadingContainer}
              >
                <Grid item>
                  <CircularProgress className={classes.loading} />
                </Grid>
              </Grid>
            )}

            {viewTabValue === "orders-map" && <MapTab hasOrders={!!orders.length} />}

            {viewTabValue === "table" && !loading && (
              <Grid item xs={12}>
                <OrdersTable
                  agencyId={agencySelected || ""}
                  t={t}
                  currentData={currentData}
                  orders={orders}
                  handleSelectRow={handleSelectRow}
                  handleTablePageChange={handleTablePageChange}
                  filter={filter}
                />
              </Grid>
            )}

          </Grid>
        </Grid>
      </Grid>

      <ModalCreateOrders
        open={state.mode === 'new-order'}
        onCancel={() => handleModalOpen(false)}
        onClose={() => handleModalOpen(false)}
      />
    </OrdersContext.Provider>
  );
};
